export default {
  setMonitoring(state, payLoad) {
    return (state.monitorings = payLoad);
  },
  setCurrentMonitoring(state, payLoad) {
    return (state.currentMonitoring = payLoad);
  },
};
